var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"cont"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"txt"},[_vm._v(_vm._s(item)+"；")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }